import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../config/axiosConfig'; 
import playerAxiosInstance from '../config/axiosConfigPlayer'; 
import { showSuccessToast, showErrorToast } from '../../components/Utils/toast';



export const fetchAdminConfig = createAsyncThunk(
  'admin/fetchAdminConfig',
  async (arg, { rejectWithValue }) => {
    // arg can be { data, onSuccess, onFailure } if you need it, but for a GET it's often not needed.
    // If you don't need arguments, you can use `_` instead of `arg`.
    const { onSuccess, onFailure } = arg || {};
    try {
      // Using api.get for fetching data. If you need to send a body, use api.post.
      const response = await api.get('/api/admin/get-social-configs?type=social-media');
      const result = response?.data?.data?.result || [];
      const socialLinks = {};
      result.forEach(item => {
        socialLinks[item.key] = item.value;
      });
      // Format WhatsApp link
      if (onSuccess) onSuccess(socialLinks); // Execute success callback
      return socialLinks;
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.[0]?.description ||
        error.response?.data?.message ||
        error.message ||
        'An unexpected error occurred.';

      if (onFailure) onFailure(errorMessage); // Execute failure callback
      return rejectWithValue(errorMessage);
    }
  },
);


// sign up 
export const signUpUserService = createAsyncThunk(
    'admin/signUpUserService',
    async (arg, { rejectWithValue }) => {
      // arg can be { data, onSuccess, onFailure } if you need it, but for a GET it's often not needed.
      // If you don't need arguments, you can use `_` instead of `arg`.
      const {data , onSuccess, onFailure } = arg || {};
      try {
        // Using api.get for fetching data. If you need to send a body, use api.post.
        const response = await playerAxiosInstance.post('/api/user/sign-up' , data);
  
       
        if (onSuccess) onSuccess(response.data); // Execute success callback
        // showSuccessToast(response.data.message|| "User Registered Successfully!");
        return response.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.errors?.[0]?.description ||
          error.response?.data?.message ||
          error.message ||
          'An unexpected error occurred.';
  
        if (onFailure) onFailure(errorMessage); // Execute failure callback
        showErrorToast(errorMessage);

        return rejectWithValue(errorMessage);
      }
    },
  );


  export const fetchCmsDetails = createAsyncThunk(
    'admin/fetchCmsDetails',
    async (arg, { rejectWithValue }) => {
      // arg can be { data, onSuccess, onFailure } if you need it, but for a GET it's often not needed.
      // If you don't need arguments, you can use `_` instead of `arg`.
      const { onSuccess, onFailure } = arg || {};
      try {
        // Using api.get for fetching data. If you need to send a body, use api.post.
        const response = await api.get('/api/admin/cms?isActive=true');
  
        // Assuming a successful response has a `data` property.
        // The check for `response.data.data.success` might be specific to your API.
        // If the request is successful, we expect the data.
        if (onSuccess) onSuccess(response.data); // Execute success callback
        return response.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.errors?.[0]?.description ||
          error.response?.data?.message ||
          error.message ||
          'An unexpected error occurred.';
  
        if (onFailure) onFailure(errorMessage); // Execute failure callback
        return rejectWithValue(errorMessage);
      }
    },
  );
  